import { render, staticRenderFns } from "./RecipeSlider.vue?vue&type=template&id=45568324"
import script from "./RecipeSlider.vue?vue&type=script&lang=js"
export * from "./RecipeSlider.vue?vue&type=script&lang=js"
import style0 from "./RecipeSlider.vue?vue&type=style&index=0&id=45568324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports